import store from 'store';

import { getTranslator } from '../js/i18n';
import tools from '../js/tools';

const t = getTranslator();

export const DIAGNOSTIC_INFO = {
    get info_browser() { return t('diagnostic.browser'); },
    get info_extension() { return t('diagnostic.extension'); },
    get info_plugin() { return t('diagnostic.plugin'); },
    get info_dspro() { return t('diagnostic.dspro'); },
    get info_wacom() { return t('diagnostic.wacom'); },
};

export function usePluginDiagnostic(_options) {
    const {
        title,
    } = _options;

    const diagnosticInfo = new Map();
    let lastError;
    let errorDetails;
    let $this;

    function setCurrentVersion(info, version, latestVersion) {
        diagnosticInfo.set(info, {
            icon: 'fa-check',
            version,
            latestVersion,
            text: DIAGNOSTIC_INFO[info],
        });
    }

    function getCurrentVersion(info) {
        return diagnosticInfo.get(info)?.version;
    }

    function markFailed(info, err, details) {
        if(info) {
            let message = diagnosticInfo.get(info);
            if(!message) {
                message = {
                    text: DIAGNOSTIC_INFO[info],
                };
                diagnosticInfo.set(info, message);
            }
            message.icon = 'fa-times';
        }

        if(!err) {
            lastError = new Error('');
        } else if(typeof (err) === 'string') {
            lastError = new Error(err);
        } else {
            lastError = err;
        }
        lastError.pluginDiagnostic = $this;
        lastError.no_show_error = true;
        errorDetails = details || undefined;
        return lastError;
    }

    function showDiagnostic(_guiHelper) {
        const rows = Object.keys(DIAGNOSTIC_INFO).map((info) => diagnosticInfo.get(info)).filter((v) => v);
        const params = {
            title,
            statusRows: rows,
            haveStatusRows: rows.length > 0,
            errorDetails: errorDetails,
        };
        if(lastError?.message) {
            const err = tools.errutil.parse(null, lastError);
            const parsed = err.parsedex;
            if(!errorDetails) {
                params.errorMessage = err.message;
            }
            params.stackTrace = err.message + '\n' + parsed.stack;
        }
        _guiHelper.showDialog2('mustache-cloudsign-extension-diagnostic-dialog', params);
    }

    function haveError() {
        return !!lastError;
    }

    function showSoftUpdateDialog(_guiHelper, _moduleRows) {
        let skipRows = 0;
        let now = new Date().getTime();
        const ONE_DAY = 1000 * 60 * 60 * 24;
        const moduleRows = _moduleRows.map(({ info, downloadUrl }) => {
            const _info = diagnosticInfo.get(info);
            const oldVersion = _info.version;
            const newVersion = _info.latestVersion;

            const storedObject = store.get('cloudsign_update_' + info) ?? {};
            if(storedObject
                && (storedObject.version === newVersion)
                && Number(storedObject.timestamp)
                && ((Number(storedObject.timestamp) + ONE_DAY) > now)
            ) {
                skipRows++;
            }

            const moduleRow = {
                info,
                oldVersion,
                newVersion,
                url: downloadUrl,
                type: DIAGNOSTIC_INFO[info],
                updateAvailable: t('plugin.update_available', { newVersion, type: DIAGNOSTIC_INFO[info] }),
                updateRecommended: t('plugin.update_recommended', { oldVersion }),
                downloadHereBefore: t('plugin.download_here_before'),
                downloadHereLink: t('plugin.download_here_link'),
                downloadHereAfter: t('plugin.download_here_after'),
            };
            return moduleRow;
        });

        if(skipRows == moduleRows.length) {
            return Promise.resolve(true);
        }

        const params = {
            moduleRows,
        };
        _guiHelper.waiting2(false);
        const _dialog = _guiHelper.showDialog2('mustache-cloudsign-plugin-update-dialog', params);
        return new Promise((resolve) => {
            let shouldContinue = false;
            _dialog.one('hide.bs.modal', function(evt) {
                _guiHelper.waiting2(true);
                if(!shouldContinue) {
                    resolve(false);
                    return;
                }
                if(_dialog.find('#mustache-cloudsign-plugin-update-dialog-checkbox').is(':checked')) {
                    now = new Date().getTime();
                    moduleRows.forEach(({ info, newVersion }) => {
                        const storedObject = {
                            version: newVersion,
                            timestamp: now,
                        };
                        store.set('cloudsign_update_' + info, storedObject);
                    });
                }
                resolve(true);
            });
            _dialog.find('.btn-continue').one('click', function() {
                shouldContinue = true;
                _dialog.modal('hide');
            });
        });
    }

    $this = {
        setCurrentVersion,
        getCurrentVersion,
        markFailed,
        showDiagnostic,
        haveError,
        showSoftUpdateDialog,
    };
    return $this;
}
